export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const SWITCH_USER_TEAM = 'SWITCH_USER_TEAM';
export const SET_TEAM_PARAM = 'SET_TEAM_PARAM';
export const FETCH_PENDING_ACTIONS_NUMBER = 'FETCH_PENDING_ACTIONS_NUMBER';
export const FETCH_ACTION_PLANS = 'FETCH_ACTION_PLANS';
export const SET_ACTION_PLAN = 'SET_ACTION_PLAN';
export const DELETE_ACTION_PLAN = 'DELETE_ACTION_PLAN';
export const FETCH_ONGOING_SECURING_ACTIONS = 'FETCH_ONGOING_SECURING_ACTIONS';
export const FETCH_ONGOING_QUICK_ACTIONS = 'FETCH_ONGOING_QUICK_ACTIONS';
export const FETCH_LIBRARY_INDICATORS = 'FETCH_LIBRARY_INDICATORS';
export const FETCH_INDICATOR = 'FETCH_INDICATOR';
export const FETCH_INDICATOR_DISPLAY_CONFIGS = 'FETCH_INDICATOR_DISPLAY_CONFIGS';
export const FETCH_INDICATOR_THEMES = 'FETCH_INDICATOR_THEMES';
export const FETCH_INDICATORS_ONLY = 'FETCH_INDICATORS_ONLY';
export const FETCH_INDICATOR_WARNINGS = 'FETCH_INDICATOR_WARNINGS';
export const SET_INDICATOR_OBJECTIVE = 'SET_INDICATOR_OBJECTIVE';
export const SET_INDICATOR_VALUE = 'SET_INDICATOR_VALUE';
export const DELETE_INDICATOR_VALUE = 'DELETE_INDICATOR_VALUE';
export const FETCH_INFOS = 'FETCH_INFOS';
export const EDIT_INFO = 'EDIT_INFO';
export const DELETE_INFO = 'DELETE_INFO';
export const FETCH_MANAGED_ACTION_PLANS = 'FETCH_MANAGED_ACTION_PLANS';
export const FETCH_MANAGED_INDICATORS = 'FETCH_MANAGED_INDICATORS';
export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_CUMULATED_INDICATORS = 'FETCH_CUMULATED_INDICATORS';
export const FETCH_TEAMS = 'FETCH_TEAMS';
export const FETCH_USERS = 'FETCH_USERS';
export const EDIT_USER = 'EDIT_USER';
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const FETCH_USER_PICTURE = 'FETCH_USER_PICTURE';
export const EDIT_USER_PICTURE = 'EDIT_USER_PICTURE';
export const DELETE_USER_PICTURE = 'DELETE_USER_PICTURE';
export const FETCH_KEYWORDS = 'FETCH_KEYWORDS';
export const FETCH_PB_TYPES = 'FETCH_PB_TYPES';
export const UPDATE_PB_TYPE = 'UPDATE_PB_TYPE';
export const CREATE_PB_TYPE = 'CREATE_PB_TYPE';
export const DELETE_PB_TYPE = 'DELETE_PB_TYPE';
export const FETCH_ZONES = 'FETCH_ZONES';
export const UPDATE_ZONE = 'UPDATE_ZONE';
export const CREATE_ZONE = 'CREATE_ZONE';
export const DELETE_ZONE = 'DELETE_ZONE';
export const FETCH_SCREEN_SAVER = 'FETCH_SCREEN_SAVER';
export const FETCH_NEXT_MEETINGS = 'FETCH_NEXT_MEETINGS';
export const FETCH_STICKERS = 'FETCH_STICKERS';
export const SET_STICKER = 'SET_STICKER';
export const DELETE_STICKER = 'DELETE_STICKER';
export const FETCH_LOGO = 'FETCH_LOGO';
export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS';
export const ASSIGN_ACTION = 'ASSIGN_ACTION';
export const RETURN_ACTION = 'RETURN_ACTION';
export const FETCH_ACTION_POSTPMT_REASONS = 'FETCH_ACTION_POSTPMT_REASONS';
export const BUFFER_FETCH_CUMULATED_INDICATORS = 'BUFFER_FETCH_CUMULATED_INDICATORS';
export const BUFFER_FETCH_INDICATORS = 'BUFFER_FETCH_INDICATORS';
export const FETCH_NOTIFICATION_SETTINGS = 'FETCH_NOTIFICATION_SETTINGS';
export const EDIT_NOTIFICATION_SETTINGS = 'EDIT_NOTIFICATION_SETTINGS';

// Cfg-page related actions
export const FETCH_MENU_CFG_PAGES = 'FETCH_MENU_CFG_PAGES';
export const FETCH_CFG_PAGES = 'FETCH_CFG_PAGES';
export const FETCH_CFG_PAGE = 'FETCH_CFG_PAGE';
export const CREATE_CFG_PAGE = 'CREATE_CFG_PAGE';
export const FETCH_CFG_PAGE_WIDGET = 'FETCH_CFG_PAGE_WIDGET';
export const SET_CFG_PAGE = 'SET_CFG_PAGE';
export const SET_CFG_PAGE_WIDGET = 'SET_CFG_PAGE_WIDGET';
export const DELETE_CFG_PAGE_WIDGET = 'DELETE_CFG_PAGE_WIDGET';
export const SET_TEXT_PER_DATE_WIDGET = 'SET_TEXT_PER_DATE_WIDGET';
export const FETCH_TEXT_PER_DATE_WIDGET = 'GET_TEXT_PER_DATE_WIDGET';

// GW related actions
export const FETCH_NEXT_GWS = 'FETCH_NEXT_GWS';
export const FETCH_GW_CL_ITEM_TEMPLATES = 'FETCH_GW_CL_ITEM_TEMPLATES';


export default {
  LOGIN,
  LOGOUT,
  CHECK_LOGIN,
  SWITCH_USER_TEAM,
  SET_TEAM_PARAM,
  FETCH_PENDING_ACTIONS_NUMBER,
  FETCH_ACTION_PLANS,
  SET_ACTION_PLAN,
  DELETE_ACTION_PLAN,
  FETCH_ONGOING_SECURING_ACTIONS,
  FETCH_ONGOING_QUICK_ACTIONS,
  FETCH_LIBRARY_INDICATORS,
  FETCH_INDICATOR,
  FETCH_INDICATOR_DISPLAY_CONFIGS,
  FETCH_INDICATOR_THEMES,
  FETCH_INDICATORS_ONLY,
  FETCH_INDICATOR_WARNINGS,
  SET_INDICATOR_OBJECTIVE,
  SET_INDICATOR_VALUE,
  DELETE_INDICATOR_VALUE,
  FETCH_INFOS,
  EDIT_INFO,
  DELETE_INFO,
  FETCH_MANAGED_ACTION_PLANS,
  FETCH_MANAGED_INDICATORS,
  FETCH_ROLES,
  FETCH_CUMULATED_INDICATORS,
  FETCH_TEAMS,
  FETCH_USERS,
  EDIT_USER,
  FETCH_USER_DATA,
  FETCH_USER_PICTURE,
  EDIT_USER_PICTURE,
  DELETE_USER_PICTURE,
  FETCH_KEYWORDS,
  FETCH_PB_TYPES,
  UPDATE_PB_TYPE,
  CREATE_PB_TYPE,
  DELETE_PB_TYPE,
  FETCH_ZONES,
  UPDATE_ZONE,
  CREATE_ZONE,
  DELETE_ZONE,
  FETCH_SCREEN_SAVER,
  FETCH_NEXT_MEETINGS,
  FETCH_STICKERS,
  SET_STICKER,
  DELETE_STICKER,
  FETCH_LOGO,
  FETCH_ANNOUNCEMENTS,
  ASSIGN_ACTION,
  RETURN_ACTION,
  FETCH_ACTION_POSTPMT_REASONS,
  BUFFER_FETCH_CUMULATED_INDICATORS,
  BUFFER_FETCH_INDICATORS,
  FETCH_NOTIFICATION_SETTINGS,
  EDIT_NOTIFICATION_SETTINGS,

  FETCH_MENU_CFG_PAGES,
  FETCH_CFG_PAGES,
  FETCH_CFG_PAGE,
  CREATE_CFG_PAGE,
  FETCH_CFG_PAGE_WIDGET,
  SET_CFG_PAGE,
  SET_CFG_PAGE_WIDGET,
  DELETE_CFG_PAGE_WIDGET,
  SET_TEXT_PER_DATE_WIDGET,
  FETCH_TEXT_PER_DATE_WIDGET,

  FETCH_NEXT_GWS,
  FETCH_GW_CL_ITEM_TEMPLATES,

};
